<template>
  <div>
      <div class="zoom-buttons">
        <v-btn 
        id="zoomOut" 
        color="midnight"
        flat
        icon="mdi-minus"
        />
        <v-btn 
        id="zoomIn" 
        color="midnight"
        flat
        icon="mdi-plus"
        />
    </div>
</div>
</template>

<script>
export default {
  name: 'ZoomButtons',
  mounted() {
    // Get the buttons
    const zoomInButton = this.$el.querySelector('#zoomIn');
    const zoomOutButton = this.$el.querySelector('#zoomOut');

    // Add event listeners
    zoomInButton.addEventListener('click', this.zoomIn);
    zoomOutButton.addEventListener('click', this.zoomOut);
  },
  methods: {
    zoomIn(event) {
      this.$emit('zoom', 1.5);
    },
    zoomOut(event) {
      this.$emit('zoom', 1 / 1.5);
    },
  },
};
</script>

<style scoped>
.zoom-buttons {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: calc((2 * 30px) + (8px));
}

.zoom-buttons .v-btn {
  border-radius: 50%;
  width: 30px;
  height: 30px;
  font-size: 12px;
}
</style>